import {
  Collapse,
  Heading,
  HStack,
  IconButton,
  StackProps,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { useGlobalState } from '@/shared/providers';
import { ArrowDown } from '@/shared/ui';
import { useSubscribeCartStoreShallow } from '../hooks/cartStoreHooks';
import { cartStoreSelectors } from '../selectors';
import CartItem from './CartItem/CartItem';
import CartTotalPriceWithShipping from './CartTotalPriceWithShipping';

type CheckoutCartProps = StackProps & {
  shippingCost?: number;
};
const CheckoutCart = ({ shippingCost, ...props }: CheckoutCartProps) => {
  const { t } = useTranslation();
  const { isMobile } = useGlobalState();
  const itemSlugs = useSubscribeCartStoreShallow(cartStoreSelectors.itemSlugs);

  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: false });

  return (
    <VStack
      align='start'
      spacing={0}
      {...props}
    >
      {isMobile ? (
        <HStack
          justify='space-between'
          pb='sm'
          w='full'
          onClick={onToggle}
        >
          <Heading
            as='h2'
            size='lg'
          >
            {t('store.checkout.orderDetails')}
          </Heading>
          <IconButton
            aria-label={isOpen ? t('store.checkout.closeDetails') : t('store.checkout.openDetails')}
            colorScheme='gray'
            icon={<ArrowDown />}
            size='xs'
            transform={isOpen ? 'rotate(180deg)' : 'rotate(0)'}
            variant='ghost'
          />
        </HStack>
      ) : (
        <Heading
          as='h2'
          mb='md'
          size='lg'
        >
          {t('store.checkout.orderDetails')}
        </Heading>
      )}
      <Collapse
        in={isMobile ? isOpen : true}
        startingHeight='1px'
        style={{ width: '100%' }}
      >
        <VStack
          opacity={!isMobile || isOpen ? 1 : 0}
          pb='md'
          w='full'
        >
          {itemSlugs.map((itemSlug) => (
            <CartItem
              key={itemSlug}
              bg='white'
              hideRemoveButton
              itemSlug={itemSlug}
            />
          ))}
        </VStack>
      </Collapse>
      <CartTotalPriceWithShipping
        borderTop='1px'
        borderTopColor='border.pure'
        pt='md'
        shippingCost={shippingCost}
      />
    </VStack>
  );
};

export default CheckoutCart;
